export default __webpack_public_path__ + "static/image--taco-01-1cb5e0bf456ed028dc8f4474019ba175.jpg";